@if (viewSegments.length > 0) {
  <section class="continuous-itinerary" [attr.aria-label]="accessibleLabel">
    <div class="itinerary-endpoint itinerary-endpoint--origin">
      <strong class="itinerary-endpoint__time">{{ viewSegments[0].departureTime }}</strong>
      <span class="itinerary-endpoint__code">{{ viewSegments[0].originCode }}</span>
      @if (viewSegments[0].originCity) {
        <small class="itinerary-endpoint__city">{{ viewSegments[0].originCity }}</small>
      }
    </div>

    <div class="itinerary-path" [class.itinerary-path--connected]="connectionCount > 0">
      <ol class="itinerary-track" aria-hidden="true">
        @for (segment of viewSegments; track $index; let isLast = $last) {
          <li class="itinerary-segment">
            <span class="itinerary-segment__line"></span>
            <span class="itinerary-segment__plane" aria-hidden="true">
              <img src="assets/images/airplane_boarding.svg" alt="" />
            </span>
            @if (!isLast) {
              <span class="itinerary-waypoint">
                <strong class="itinerary-waypoint__code">{{ segment.destinationCode }}</strong>
                <span class="itinerary-waypoint__dot"></span>
                <small class="itinerary-waypoint__time">
                  {{ segment.arrivalTime }} <span aria-hidden="true">–</span> {{ viewSegments[$index + 1].departureTime }}
                </small>
                <small class="itinerary-waypoint__connection">
                  @if (connectionCount === 1) {
                    1 conexão
                  } @else {
                    Conexão {{ $index + 1 }} de {{ connectionCount }}
                  }
                </small>
              </span>
            }
          </li>
        }
      </ol>

      @if (connectionCount === 0) {
        <div class="itinerary-summary">
          <span>Voo direto@if (viewSegments[0].duration) { · {{ viewSegments[0].duration }} }</span>
        </div>
      }
    </div>

    <div class="itinerary-endpoint itinerary-endpoint--destination">
      <span class="itinerary-endpoint__arrival">
        <strong class="itinerary-endpoint__time">{{ viewSegments[viewSegments.length - 1].arrivalTime }}</strong>
        @if (viewSegments[viewSegments.length - 1].arrivesNextDay) {
          <small class="itinerary-endpoint__day">+1 dia</small>
        }
      </span>
      <span class="itinerary-endpoint__code">{{ viewSegments[viewSegments.length - 1].destinationCode }}</span>
      @if (viewSegments[viewSegments.length - 1].destinationCity) {
        <small class="itinerary-endpoint__city">{{ viewSegments[viewSegments.length - 1].destinationCity }}</small>
      }
    </div>
  </section>
}
